<template>
  <div class="banner grid">
    <button
      class="clear-connections btn btn-stretch btn-extra-round text-bold"
      v-if="isShowingLinks && hasActiveLinks({ interaction })"
      @click="clearConnections($event, null, interaction)"
    >
      Limpar
    </button>

    <div class="grid-center">
      <button
        class="clear-connections btn btn-stretch btn-extra-round text-bold"
        v-if="isShowingLinks && hasActiveLinks"
        @click="clearConnections($event)"
      >
        Limpar conexões
      </button>
      <div v-if="!hasMediaMobile && !isCloudflareVideo" class="placeholder">
        <v-icon size="100">mdi-video-outline</v-icon>

        <div class="text">
          Insira o link do vídeo no painel lateral <br />
          <span v-if="userCanUploadVideo"
            >ou selecione o arquivo de vídeo desejado</span
          >
        </div>
      </div>
      <img
        v-else
        :src="playerLogo"
        alt="player-logo"
        class="player-logo"
        :class="{ generic: dataInteraction.isCloudflareVideo }"
      />
    </div>

    <div class="text-center grid-bottom">
      <button
        id="0"
        class="btn btn-stretch btn-extra-round text-bold"
        :style="buttonStyle(firstOption.estilo)"
        ref="button"
        @click="(event) => showLinks({ event, interaction })"
      >
        {{ firstOption.nome }}
      </button>
    </div>
  </div>
</template>

<script>
import buttonStyle from "../../../mixins/button-style";
import mode from "../../../mixins/mode";
import linkable from "../../../mixins/linkable";

export default {
  data() {
    return {};
  },

  components: {},

  props: {
    dataInteraction: {
      type: Object,
      required: true,
    },
  },

  computed: {
    options() {
      return this.dataInteraction.opcoes;
    },

    firstOption() {
      return (
        this.options[0] || {
          estilo: null,
          nome: null,
        }
      );
    },

    secondOption() {
      return (
        this.options[1] || {
          estilo: null,
          nome: null,
        }
      );
    },

    itemStyle() {
      return this.dataInteraction.estilo ? this.dataInteraction.estilo : null;
    },

    backgroundType() {
      return this.itemStyle ? this.itemStyle.backgroundType : null;
    },

    playerLogo() {
      const playerType = this.dataInteraction.isCloudflareVideo
        ? "generic-player"
        : "youtube";
      return require(`@assets/images/${playerType}.png`);
    },

    hasMediaMobile() {
      return this.dataInteraction.mediaMobile;
    },

    isCloudflareVideo() {
      return this.dataInteraction.isCloudflareVideo;
    },

    permissions() {
      return this.$store.state.users.user.permissions;
    },

    userCanUploadVideo() {
      return !!this.permissions.find((x) => x === "ALLOW_VIDEO_UPLOAD");
    },
  },

  mixins: [buttonStyle, mode, linkable],
};
</script>

<style lang="scss" scoped>
@import "~@variables";

.banner {
  &.grid {
    .grid-center {
      margin: 0 auto;

      .player-logo {
        width: 88px;
        height: 48px;
        position: absolute;
        left: 35%;
        top: 45%;

        &.generic {
          width: 57px;
          height: 56px;
          left: 40%;
        }
      }

      .placeholder {
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;

        i {
          color: rgba($grey-5, 0.1);
        }

        .text {
          text-align: center;
          font-size: 12px;
          color: rgba($grey-5, 0.5);
          margin: 12px;
        }

        .btn {
          font-size: 12px;
        }
        .btn-background {
          font-size: 14px;
        }
      }
    }
    .grid-bottom {
      gap: 2.5%;
      margin: 0 2.5%;
    }

    .btn {
      &.clear-connections {
        font-size: 14px;
        position: fixed;
        bottom: 15px;
        left: 40%;
        min-width: 0 !important;
        width: 20% !important;
        background-color: #2a7155;
        z-index: 10000;
        color: white;
        min-width: 0;

        &:hover {
          transform: translateY(-1px);
        }

        &:active {
          transform: translateY(1px);
        }
      }
    }
  }
}
</style>
